// Global price formatting function
window.formatPrice = function(priceInCents, options = {}) {
    if (typeof priceInCents !== 'number' || isNaN(priceInCents)) {
        return options.rounded ? '€0' : '€0,00';
    }

    const majorUnit = priceInCents / 100;
    const moneyFormat = window.themeVariables?.settings?.moneyFormat;

    // console.log('Global formatPrice debug:', {
    //     priceInCents,
    //     majorUnit,
    //     moneyFormat
    // });

    if (!moneyFormat) {
        // console.log('No moneyFormat found, using fallback');
        if (options.rounded) {
            return `€${Math.round(majorUnit)}`;
        }
        return `€${majorUnit.toFixed(2).replace('.', ',')}`;
    }

    // Handle comma separator (€{{amount_with_comma_separator}})
    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
        if (options.rounded) {
            // Format rounded amount with thousands separator (dot)
            const roundedAmount = Math.round(majorUnit);
            const formattedRounded = roundedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return moneyFormat.replace('{{amount_with_comma_separator}}', formattedRounded);
        }

        // Format with thousands separator (dot) and decimal separator (comma)
        const parts = majorUnit.toFixed(2).split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const decimalPart = parts[1];
        const commaAmount = `${integerPart},${decimalPart}`;

        const result = moneyFormat.replace('{{amount_with_comma_separator}}', commaAmount);
        // console.log('Global comma separator formatting:', {
        //     majorUnit,
        //     integerPart,
        //     decimalPart,
        //     commaAmount,
        //     moneyFormat,
        //     result
        // });
        return result;
    }

    // Handle other common placeholders
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
        const noDecimalAmount = Math.round(majorUnit).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return moneyFormat.replace('{{amount_no_decimals}}', noDecimalAmount);
    }

    if (moneyFormat.includes('{{amount}}')) {
        if (options.rounded) {
            const amount = Math.round(majorUnit).toString();
            return moneyFormat.replace('{{amount}}', amount);
        }
        const amount = majorUnit.toFixed(2);
        return moneyFormat.replace('{{amount}}', amount);
    }

    // Generic fallback with thousands separator
    // console.log('Using generic fallback replacement');
    if (options.rounded) {
        const roundedAmount = Math.round(majorUnit);
        const formattedRounded = roundedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return moneyFormat.replace(/\{\{[^}]+\}\}/, formattedRounded);
    }

    const parts = majorUnit.toFixed(2).split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const decimalPart = parts[1];
    const formattedAmount = `${integerPart},${decimalPart}`;
    return moneyFormat.replace(/\{\{[^}]+\}\}/, formattedAmount);
};

(function() {
    'use strict';

    function updateCardSwatches(scope) {
        var root = scope || document;
        var groups = root.querySelectorAll('.product-card__swatches');

        groups.forEach(function(group) {
            var swatches = Array.from(group.querySelectorAll('.color-swatch'));
            var more = group.querySelector('.product-card__swatch-more');

            if (!swatches.length || !more) {
                return;
            }

            swatches.forEach(function(el) {
                el.hidden = false;
            });

            more.hidden = true;
            more.textContent = '';

            var availableWidth = group.clientWidth;
            if (availableWidth <= 0) {
                return;
            }

            var groupStyle = window.getComputedStyle(group);
            var gap = parseFloat(groupStyle.columnGap || groupStyle.gap || '0') || 0;
            var widths = swatches.map(function(el) {
                return el.offsetWidth;
            });
            var totalSwatchesWidth = 0;
            widths.forEach(function(width, index) {
                totalSwatchesWidth += width + (index > 0 ? gap : 0);
            });

            if (totalSwatchesWidth <= availableWidth) {
                return;
            }

            var visibleCount = swatches.length;
            var hiddenCount = 0;
            var visibleWidth = totalSwatchesWidth;

            while (visibleCount > 1) {
                hiddenCount = swatches.length - visibleCount;
                more.hidden = false;
                more.textContent = '+' + hiddenCount;

                var moreWidth = more.offsetWidth + (visibleCount > 0 ? gap : 0);

                if (visibleWidth + moreWidth <= availableWidth) {
                    break;
                }

                visibleCount -= 1;
                hiddenCount += 1;
                visibleWidth -= widths[visibleCount] + (visibleCount > 0 ? gap : 0);
            }

            var extraHiddenInFirstRow = 1;
            visibleCount = Math.max(1, visibleCount - extraHiddenInFirstRow);

            more.hidden = false;
            more.textContent = '+' + (swatches.length - visibleCount);

            swatches.forEach(function(el, index) {
                el.hidden = index >= visibleCount;
            });
        });
    }

    var timer;
    function refreshSwatches() {
        window.clearTimeout(timer);
        timer = window.setTimeout(function() {
            updateCardSwatches(document);
        }, 80);
    }

    document.addEventListener('DOMContentLoaded', function() {
        updateCardSwatches(document);
    });
    window.addEventListener('load', refreshSwatches);
    window.addEventListener('resize', refreshSwatches);
    document.addEventListener('shopify:section:load', function(event) {
        updateCardSwatches(event.target);
    });
})();
